"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var bubble_1 = require("../../constants/bubble");
var ConfigurationPanelContent_1 = tslib_1.__importDefault(require("./ConfigurationPanelContent"));
var CheckboxControl_1 = tslib_1.__importDefault(require("../configurationControls/CheckboxControl"));
var ConfigSection_1 = tslib_1.__importDefault(require("../configurationControls/ConfigSection"));
var PushpinSizeControl_1 = tslib_1.__importDefault(require("../configurationControls/PushpinSizeControl"));
var PushpinViewportControl_1 = tslib_1.__importDefault(require("../configurationControls/PushpinViewportControl"));
var LegendSection_1 = tslib_1.__importDefault(require("../configurationControls/legend/LegendSection"));
var ColorsSection_1 = tslib_1.__importDefault(require("../configurationControls/colors/ColorsSection"));
var GeoPushpinConfigurationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPushpinConfigurationPanel, _super);
    function GeoPushpinConfigurationPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GeoPushpinConfigurationPanel.prototype.getControlProperties = function () {
        var _a, _b, _c, _d;
        var groupNearbyPoints = (_d = (_c = (_b = (_a = this.props.properties) === null || _a === void 0 ? void 0 : _a.controls) === null || _b === void 0 ? void 0 : _b.points) === null || _c === void 0 ? void 0 : _c.groupNearbyPoints) !== null && _d !== void 0 ? _d : true;
        return {
            groupNearbyPoints: groupNearbyPoints,
        };
    };
    GeoPushpinConfigurationPanel.prototype.renderLegendSection = function () {
        var _a = this.props, insight = _a.insight, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData;
        var isLegendVisible = hasSegmentAttribute(insight) || hasColorMeasure(insight) || hasSizeMeasure(insight);
        var controlsDisabled = this.isControlDisabled() || !isLegendVisible;
        return (react_1.default.createElement(LegendSection_1.default, { properties: properties, propertiesMeta: propertiesMeta, controlsDisabled: controlsDisabled, pushData: pushData }));
    };
    GeoPushpinConfigurationPanel.prototype.renderViewportSection = function () {
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData;
        return (react_1.default.createElement(ConfigSection_1.default, { id: "map_section", title: "properties.map.title", propertiesMeta: propertiesMeta, properties: properties, pushData: pushData },
            react_1.default.createElement(PushpinViewportControl_1.default, { properties: properties, disabled: this.isControlDisabled(), pushData: pushData })));
    };
    GeoPushpinConfigurationPanel.prototype.renderPointsSection = function () {
        var groupNearbyPoints = this.getControlProperties().groupNearbyPoints;
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData, insight = _a.insight;
        var isControlDisabled = this.isControlDisabled();
        var isClusteringDisabled = isControlDisabled || sdk_model_1.insightHasMeasures(insight) || hasSegmentAttribute(insight);
        var isPushpinSizeControlDisabled = isControlDisabled || !hasSizeMeasure(insight);
        return (react_1.default.createElement(ConfigSection_1.default, { id: "points_section", title: "properties.points.title", propertiesMeta: propertiesMeta, properties: properties, pushData: pushData },
            react_1.default.createElement(CheckboxControl_1.default, { valuePath: "points.groupNearbyPoints", labelText: "properties.points.groupNearbyPoints", properties: properties, checked: groupNearbyPoints, disabled: isClusteringDisabled, showDisabledMessage: isClusteringDisabled, pushData: pushData }),
            react_1.default.createElement(PushpinSizeControl_1.default, { properties: properties, disabled: isPushpinSizeControlDisabled, pushData: pushData })));
    };
    GeoPushpinConfigurationPanel.prototype.isControlDisabled = function () {
        var _a = this.props, insight = _a.insight, isError = _a.isError, isLoading = _a.isLoading;
        return !hasLocationAttribute(insight) || isError || isLoading;
    };
    GeoPushpinConfigurationPanel.prototype.getBubbleClassNames = function () {
        return classnames_1.default("bubble-primary", {
            invisible: !this.isControlDisabled(),
        });
    };
    GeoPushpinConfigurationPanel.prototype.renderConfigurationPanel = function () {
        return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: bubble_1.SHOW_DELAY_DEFAULT, hideDelay: bubble_1.HIDE_DELAY_DEFAULT },
            react_1.default.createElement("div", null,
                this.renderColorSection(),
                this.renderLegendSection(),
                this.renderViewportSection(),
                this.renderPointsSection()),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: this.getBubbleClassNames(), arrowOffsets: { "tc bc": [bubble_1.BUBBLE_ARROW_OFFSET_X, bubble_1.BUBBLE_ARROW_OFFSET_Y] }, alignPoints: [{ align: "tc bc" }] },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "properties.config.not_applicable" }))));
    };
    GeoPushpinConfigurationPanel.prototype.renderColorSection = function () {
        var _a = this.props, properties = _a.properties, propertiesMeta = _a.propertiesMeta, pushData = _a.pushData, colors = _a.colors, featureFlags = _a.featureFlags, references = _a.references, isLoading = _a.isLoading;
        var controlsDisabled = this.isControlDisabled();
        return (react_1.default.createElement(ColorsSection_1.default, { properties: properties, propertiesMeta: propertiesMeta, references: references, colors: colors, controlsDisabled: controlsDisabled, pushData: pushData, hasMeasures: true, showCustomPicker: featureFlags.enableCustomColorPicker, isLoading: isLoading }));
    };
    return GeoPushpinConfigurationPanel;
}(ConfigurationPanelContent_1.default));
exports.default = GeoPushpinConfigurationPanel;
function hasColorMeasure(insight) {
    var bucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.COLOR);
    return bucket !== undefined && !sdk_model_1.bucketIsEmpty(bucket);
}
function hasSizeMeasure(insight) {
    var bucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.SIZE);
    return bucket !== undefined && !sdk_model_1.bucketIsEmpty(bucket);
}
function hasLocationAttribute(insight) {
    var bucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.LOCATION);
    return bucket !== undefined && !sdk_model_1.bucketIsEmpty(bucket);
}
function hasSegmentAttribute(insight) {
    var bucket = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.SEGMENT);
    return bucket !== undefined && !sdk_model_1.bucketIsEmpty(bucket);
}
//# sourceMappingURL=GeoPushpinConfigurationPanel.js.map